import { Injectable } from '@angular/core'
import { HttpService, Organization } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export interface Suppliers extends LibraryModel {
    organizationId?: string
    organization?: Organization
    sapCode?: string
    country?: {
        id: string
        code: string
    }
    types?: Array<{
        id: string
        code: string
    }>
    supplierStatus?: boolean
    catalogUploadedBy?: string
    hasVisibilityRules?: boolean
    visibleTo?: Array<{
        id: string
        code: string
    }>
    visibleToSuppliers?: Array<LibraryAttributeWithDescription>
    new?: boolean
    semiFinishedSupplier?: boolean
}
export interface LibraryAttributeWithDescription {
    id: string
    code: string
    companyName?: string
}
export const url = '/libraries/management/types/supplier/entries'

@Injectable()
export class SuppliersService {
    constructor(private http: HttpService) {}

    getAll(): Observable<Suppliers[]> {
        return this.http.get<Suppliers[]>(url)
    }

    remove(data: Suppliers[]): Observable<void> {
        return this.http.delete(url, { data })
    }

    create(data: Suppliers[]): Observable<Suppliers[]> {
        return this.http.post<Suppliers[]>(url, { data })
    }
    update(data: Suppliers[]): Observable<Suppliers[]> {
        return this.http.put<Suppliers[]>(url, { data })
    }
}
